/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsissueseats2Inputs */

const en_ticketsissueseats2 = /** @type {(inputs: Ticketsissueseats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the seats as a whole number or leave the field empty.`)
};

const de_ticketsissueseats2 = /** @type {(inputs: Ticketsissueseats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib die Plätze als ganze Zahl an oder lass das Feld leer.`)
};

/**
* | output |
* | --- |
* | "Enter the seats as a whole number or leave the field empty." |
*
* @param {Ticketsissueseats2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissueseats2 = /** @type {((inputs?: Ticketsissueseats2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissueseats2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissueseats2(inputs)
	return de_ticketsissueseats2(inputs)
});
export { ticketsissueseats2 as "ticketsIssueSeats" }